/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef, useRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Divider from "@mui/material/Divider";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import TeacherSearch from "./TeacherSearch";
import {
    Select,
    MenuItem,
    AppBar,
    Toolbar,
    Typography,
    RadioGroup,
    Radio,
    FormControlLabel,
    FormLabel,
    Checkbox,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    createTheme,
    ThemeProvider,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";
import { lightGreen } from "@mui/material/colors";
import RegisterFormAddr from './RegisterFormAddr';
import { MonthPicker } from '@mui/x-date-pickers';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import styled from 'styled-components';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const Input = styled('input')({
    display: 'none',
});

const itemsTheme = createTheme({
    components: {
        MuiTableRow: {
            styleOverrides: {
                root: {
                    cursor: 'pointer',
                }
            }
        }
    }
})

// 등록하기 팝업
function ResumeAdd(props) {
  const [file, setFile] = useState('');
  const [image, setImage] = useState(null);

    const onImageChange = (e) => {
        // setFileName(fileBlob.name);
        // const reader = new FileReader();
        // reader.readAsDataURL(fileBlob);
        // return new Promise((resolve) => {
        //     reader.onload = () => {
        //         setImage(reader.result);
        //         resolve();
        //     }
        // })
        let reader = new FileReader();
        reader.onloadend = () => {
          const base64 = reader.result;
          if(base64) {
            setFile(base64.toString());
          }
        }
        if(e.target.files[0]) {
          reader.readAsDataURL(e.target.files[0]);
          setImage(e.target.files[0]);
        }
    }

    console.log(image)

    return (
        <Box>
            <Box
                css={css`
                    padding: 20px 60px;
                `}
            >
                {/* 기본정보 */}
                <Box
                    sx={{
                        fontWeight: 'bold',
                        fontSize: '18px'
                    }}>
                    기본정보
                </Box>

                <Box sx={{ mt: 1 }}>
                    <Box sx={{ mt: 1 }}>
                        {/* {(file === null || file === undefined) && (
                            <Box
                                sx={{
                                    border: '1px solid black',
                                    width: '104px',
                                    height: '104px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    borderRadius: '50%',
                                }}>
                                104 X 104
                            </Box>
                        )}
                        {(file !== null && file !== undefined) && (
                            image && <Box
                                sx={{
                                    width: '104px',
                                    height: '104px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    backgroundImage: `url(${image})`,
                                    backgroundSize: 'cover',
                                    borderRadius: '50%',
                                }}>
                            </Box>
                        )} */}
                        <Box
                          sx={{
                            width: '104px',
                            height: '104px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundImage: `url(${file})`,
                            backgroundSize: 'cover',
                            borderRadius: '50%',
                          }}>
                            
                        </Box>
                        {/* <label
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                marginTop: '12px'
                            }}>

                            <Button variant='contained' component='span'>
                                이미지 첨부
                            </Button>
                            {(file === null || file === undefined) && (
                                <Box component='span' sx={{ marginLeft: '10px', fontSize: '14px' }}>이미지를 선택하세요</Box>
                            )}
                            {(file !== null && file !== undefined) && (
                                <Box component='span' sx={{ marginLeft: '10px', fontSize: '14px' }}>{file.name}</Box>
                            )}
                            <Input accept='image/jpeg' type='file' onChange={(e) => onImageChange(e.target.files[0])} sx={{ visibility: 'hidden' }} />


                        </label> */}
                        <input accept='image/jpeg' type="file" onChange={onImageChange} />

                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
export default ResumeAdd;